import React, { useState } from "react";
import { Button, ImageSeparator } from "components";
import { useCurrentUser } from "utils/hooks";
import PlanSelection from "components/elements/PlanSelection/PlanSelection";
import PartyIcon from "assets/icons/party-horn.svg";
import UpgradeSplash from "assets/images/splashes/splash-1.png";
import "./UpgradeMessage.styles.scss";

interface UpgradeMessageProps {
  heading?: string;
  limitedEntity: string;
  warningLine?: string;
  valueLine?: string;
  ctaText?: string;
}

const UpgradeMessage = ({
  heading,
  limitedEntity,
  warningLine,
  valueLine,
  ctaText,
}: UpgradeMessageProps) => {
  const { user } = useCurrentUser();
  const [showPlanSelection, setShowPlanSelection] = useState(false);

  const handleUpgradeButton = () => {
    setShowPlanSelection(true);
  };

  const handlePlanSelected = () => {
    setShowPlanSelection(false);
    // The plan selection component will handle the redirect to Stripe
  };

  const handleCancelPlanSelection = () => {
    setShowPlanSelection(false);
  };

  if (showPlanSelection) {
    return (
      <div className="upgrade-message-modal">
        <PlanSelection
          organizationId={user?.activeOrganizationId || ""}
          onPlanSelected={handlePlanSelected}
          onCancel={handleCancelPlanSelection}
        />
      </div>
    );
  }

  return (
    <div className="upgrade-message">
      <h2>{heading || "Unlock more!"}</h2>
      <p>
        {warningLine ||
          `You've reached the limit of how many ${limitedEntity} you can add
          on your current plan.`}
      </p>
      <p>
        {valueLine ||
          `Upgrade your account to add additional ${limitedEntity} and more!`}
      </p>
      <ImageSeparator image={UpgradeSplash} alt="upgrade icon" />
      <Button
        name="upgrade_button"
        value={ctaText || "Upgrade now"}
        pill
        fullWidth
        icon={PartyIcon}
        onClick={handleUpgradeButton}
      />
    </div>
  );
};

export default UpgradeMessage;
